import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BrandLogo from '../brand/BrandLogo';

export default function AuthAside() {
  const { t } = useTranslation('auth');

  return (
    <aside className="acc-auth-aside">
      <div className="acc-auth-aside__eyebrow">{t('shell.eyebrow')}</div>
      <Link to="/" className="acc-auth-aside__brand-link">
        <BrandLogo variant="auth" tone="light" />
      </Link>
      <div className="acc-auth-aside__copy">
        <h2 className="acc-auth-aside__title">{t('shell.title')}</h2>
        <p className="acc-auth-aside__description">{t('shell.description')}</p>
      </div>
      <div className="acc-auth-aside__signals">
        <span className="acc-auth-signal">{t('shell.signals.governance')}</span>
        <span className="acc-auth-signal">{t('shell.signals.operations')}</span>
        <span className="acc-auth-signal">{t('shell.signals.readiness')}</span>
      </div>
    </aside>
  );
}
